import { render, staticRenderFns } from "./DialogUpdateTaskDetail.vue?vue&type=template&id=b6e528a6&scoped=true"
import script from "./DialogUpdateTaskDetail.vue?vue&type=script&lang=js"
export * from "./DialogUpdateTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./DialogUpdateTaskDetail.vue?vue&type=style&index=0&id=b6e528a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e528a6",
  null
  
)

export default component.exports